"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.wrapRootElement = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHead = require("react-head");

var wrapRootElement = function wrapRootElement(_ref) {
  var element = _ref.element;
  return _react["default"].createElement(_reactHead.HeadProvider, null, element);
};

exports.wrapRootElement = wrapRootElement;